export class SAMLCallback400Response {
    'error';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": "tobedefined"
        }
    ];
    static getAttributeTypeMap() {
        return SAMLCallback400Response.attributeTypeMap;
    }
    constructor() {
    }
}
